import { createContext } from 'react';
import { type ChartPreferencesRecord, type ChartPreferencesType } from '@trinity/chat/types/chart-preferences';

export type UpdateChartPreferencesOverride = (data: {
  recordId: number;
  overrideChartTypes: ChartPreferencesType[];
}) => Promise<{
  record: ChartPreferencesRecord;
}>;
export type CreateChartPreferencesRecord = (data: {
  initialChartType: ChartPreferencesType;
}) => Promise<{
  record: ChartPreferencesRecord;
}>;

export const UpdateChartPreferencesContext = createContext<UpdateChartPreferencesOverride>(null);
export const CreateChartPreferencesRecordContext = createContext<CreateChartPreferencesRecord>(null);